import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 864.000000 1184.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1184.000000) scale(0.100000,-0.100000)">

<path d="M3383 7083 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M3263 7073 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M3168 7053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3070 7025 c-33 -19 -21 -19 21 0 19 8 27 14 19 14 -8 0 -26 -6 -40
-14z"/>
<path d="M2863 6918 c-98 -66 -215 -182 -275 -273 -57 -87 -69 -111 -61 -119
3 -3 1 -6 -6 -6 -7 0 -10 -4 -7 -8 3 -5 31 -10 63 -11 32 -1 73 -4 90 -6 19
-2 36 2 43 11 7 8 9 14 5 14 -4 0 3 9 16 19 18 15 21 22 12 31 -8 9 -13 7 -18
-9 -6 -21 -25 -30 -25 -12 0 13 -34 8 -46 -8 -6 -7 -32 -17 -58 -21 -57 -8
-70 7 -35 42 12 13 19 17 15 11 -4 -7 -2 -13 3 -13 6 0 11 -4 11 -10 0 -5 -9
-10 -20 -10 -11 0 -20 -4 -20 -8 0 -5 24 -4 52 2 48 10 50 11 23 16 -18 4 -29
11 -27 20 2 7 -2 16 -8 20 -6 4 -8 14 -4 23 3 9 11 14 17 10 6 -4 8 0 4 10 -8
20 3 22 23 5 8 -7 6 -2 -5 11 -18 22 -18 24 -2 18 12 -4 16 -3 11 4 -3 6 4 17
15 26 12 8 20 20 18 26 -4 12 16 37 28 37 4 0 4 -7 1 -16 -3 -9 -2 -12 5 -9 6
4 8 13 5 21 -3 8 8 28 25 45 30 30 31 31 52 12 19 -15 20 -16 8 0 -11 14 -11
17 0 17 11 0 12 2 1 9 -10 6 -6 13 15 27 15 10 32 17 36 16 5 -1 6 2 2 8 -9
14 8 13 25 -2 12 -11 12 -10 2 3 -11 14 -6 20 33 43 40 24 54 36 41 36 -2 0
-40 -24 -83 -52z m-163 -392 c0 -8 -4 -18 -10 -21 -5 -3 -10 -2 -10 4 0 6 -8
7 -17 4 -16 -6 -16 -5 -4 10 17 21 41 22 41 3z"/>
<path d="M3045 6830 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M2965 6780 c-3 -5 -13 -6 -23 -3 -9 3 -14 3 -10 -1 10 -11 -54 -67
-69 -62 -7 3 -12 2 -12 -2 3 -20 -2 -32 -11 -27 -6 4 -7 12 -4 18 4 8 2 7 -7
-1 -11 -11 -12 -14 -1 -21 10 -6 8 -10 -7 -14 -12 -3 -20 -11 -19 -18 2 -7 -1
-14 -7 -14 -5 -1 -18 -5 -28 -10 -15 -6 -15 -10 -5 -23 11 -14 10 -15 -7 -8
-16 6 -17 5 -8 -5 10 -10 24 0 68 48 31 34 83 82 116 107 34 25 56 46 51 46
-6 0 -13 -4 -17 -10z m-182 -165 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16
15 13 8 -4z"/>
<path d="M3350 6749 c-46 -28 -45 -28 -33 -40 15 -15 63 -20 63 -7 0 6 -9 8
-19 5 -17 -4 -18 -2 -9 19 6 13 17 24 24 24 7 0 16 5 19 10 10 16 -7 12 -45
-11z"/>
<path d="M3545 6750 c-3 -5 0 -10 7 -10 10 0 10 -2 1 -8 -8 -5 -9 -13 -3 -22
8 -12 10 -12 10 3 0 11 5 17 13 14 6 -2 11 -14 10 -25 -2 -15 2 -20 12 -16 8
4 15 12 15 19 0 19 -57 58 -65 45z"/>
<path d="M3190 6730 c11 -7 12 -12 3 -21 -13 -13 -37 -3 -28 12 8 11 -6 12
-24 0 -18 -12 -5 -32 16 -24 10 4 14 2 9 -5 -3 -6 -1 -14 5 -18 8 -4 9 -3 5 4
-4 7 -2 12 4 12 17 0 37 23 32 38 -2 6 -11 12 -20 12 -15 0 -15 -2 -2 -10z"/>
<path d="M3481 6708 c-1 -15 -5 -30 -11 -33 -9 -6 -14 8 -11 28 0 4 -3 7 -9 7
-5 0 -10 -7 -10 -15 0 -8 0 -18 0 -22 0 -4 13 -9 30 -11 32 -3 34 3 20 48 l-8
25 -1 -27z"/>
<path d="M3100 6700 c-12 -8 -12 -10 3 -16 21 -8 35 2 21 16 -5 5 -15 6 -24 0z"/>
<path d="M3730 6685 c-7 -8 -9 -15 -4 -16 52 -6 64 -5 64 8 0 7 -4 13 -10 13
-5 0 -10 -4 -10 -8 0 -5 -7 -9 -15 -9 -9 0 -14 6 -11 14 7 17 1 17 -14 -2z"/>
<path d="M3140 6670 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3307 6669 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M2658 6663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3249 6665 c-1 -3 -2 -8 -3 -12 -1 -5 -5 -15 -10 -23 -7 -12 -6 -13
4 -3 13 12 23 43 14 43 -2 0 -5 -2 -5 -5z"/>
<path d="M3793 6651 c-26 -22 -31 -43 -8 -35 8 3 13 11 12 17 -1 7 4 11 11 10
6 -2 12 4 12 12 0 19 0 19 -27 -4z"/>
<path d="M3014 6644 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z"/>
<path d="M2721 6633 c7 -12 15 -20 18 -17 3 2 -3 12 -13 22 -17 16 -18 16 -5
-5z"/>
<path d="M3340 6640 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3044 6621 c4 -5 0 -11 -6 -14 -7 -3 3 -4 22 -4 28 2 34 -1 32 -15
-2 -11 3 -18 13 -18 25 0 17 24 -14 43 -31 18 -56 23 -47 8z"/>
<path d="M3425 6620 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2620 6609 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2950 6585 c-18 -19 -32 -36 -29 -38 2 -2 19 14 38 35 42 48 36 50
-9 3z"/>
<path d="M3346 6603 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M3461 6598 c1 -16 3 -18 6 -6 2 9 14 19 26 21 18 4 17 5 -5 6 -23 1
-28 -3 -27 -21z"/>
<path d="M3247 6595 c3 -8 9 -12 14 -9 12 7 11 11 -5 17 -10 4 -13 1 -9 -8z"/>
<path d="M3410 6590 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M2615 6579 c-9 -14 -2 -20 14 -10 8 6 9 11 3 15 -6 3 -14 1 -17 -5z"/>
<path d="M3046 6581 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z"/>
<path d="M3290 6569 c0 -5 4 -9 9 -9 5 0 16 -3 25 -6 9 -3 16 -2 16 4 0 5 -11
12 -25 14 -14 3 -25 1 -25 -3z"/>
<path d="M3090 6551 c-8 -6 -18 -7 -23 -4 -5 3 -4 -4 2 -16 7 -11 14 -21 17
-21 3 0 2 5 -1 10 -3 6 -2 10 3 10 6 0 12 7 16 15 6 17 6 18 -14 6z"/>
<path d="M3161 6533 c-8 -17 -5 -19 22 -22 18 -1 43 -4 57 -6 14 -2 31 -4 38
-4 6 -1 12 -6 12 -12 0 -7 -12 -10 -29 -7 -17 2 -28 1 -25 -4 9 -15 64 -9 64
7 0 17 -67 48 -83 38 -6 -3 -7 -1 -3 5 4 7 3 12 -3 12 -5 0 -16 3 -24 6 -9 3
-20 -2 -26 -13z"/>
<path d="M3517 6543 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M3460 6530 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3750 6522 c0 -8 -5 -10 -12 -6 -10 5 -10 4 -1 -6 16 -17 35 -9 23
10 -7 11 -10 11 -10 2z"/>
<path d="M2905 6500 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3051 6497 c-8 -10 -7 -14 2 -14 8 0 14 6 14 14 0 7 -1 13 -2 13 -2
0 -8 -6 -14 -13z"/>
<path d="M2938 6493 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2978 6483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3186 6478 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4
-9 -9z"/>
<path d="M3315 6480 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M3400 6468 c0 -4 33 -8 73 -7 84 1 79 6 -10 11 -35 3 -63 1 -63 -4z"/>
<path d="M3610 6460 c14 -4 36 -8 50 -8 l25 0 -25 8 c-14 4 -36 8 -50 8 l-25
0 25 -8z"/>
<path d="M3708 6453 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M4026 6447 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M1972 6301 c-8 -4 -11 -96 -12 -281 0 -151 -1 -281 0 -287 0 -17 306
-18 361 -1 51 15 114 70 141 122 30 58 37 185 13 257 -23 69 -92 139 -160 163
-29 10 -94 19 -155 22 -58 3 -121 6 -141 8 -20 2 -41 1 -47 -3z m305 -144 c50
-26 77 -80 77 -152 0 -129 -80 -191 -218 -171 l-46 7 0 163 c0 89 3 166 8 170
12 13 145 0 179 -17z"/>
<path d="M2720 6258 c-75 -181 -210 -525 -210 -535 0 -18 113 -18 127 0 6 6
27 57 47 112 56 151 97 245 106 245 4 0 19 -30 33 -67 l25 -68 -40 -3 c-41 -3
-55 -21 -73 -95 l-7 -27 70 0 c39 0 77 -3 86 -6 8 -3 22 -28 31 -55 9 -27 25
-54 35 -59 24 -13 107 -13 115 0 8 12 -200 561 -217 571 -7 5 -37 9 -66 9 -45
0 -54 -3 -62 -22z"/>
<path d="M3035 6247 c-4 -8 -5 -32 -3 -53 l3 -39 50 -3 c28 -1 65 -5 84 -8
l34 -5 -6 -209 c-4 -115 -4 -216 -1 -224 5 -12 21 -16 65 -16 l59 0 0 213 c0
116 4 218 9 225 6 10 28 13 82 10 l74 -3 3 49 c2 27 0 52 -5 57 -4 4 -106 10
-225 14 -190 7 -218 6 -223 -8z"/>
<path d="M3667 6233 c-3 -5 -53 -127 -112 -272 -65 -162 -103 -267 -97 -273 5
-5 33 -8 62 -6 l54 3 38 100 c90 233 103 265 109 265 8 0 49 -112 49 -134 0
-9 -6 -16 -12 -15 -45 6 -56 -2 -72 -48 -9 -26 -16 -50 -16 -54 0 -5 35 -9 77
-11 l77 -3 21 -55 21 -55 63 -3 c61 -3 63 -3 56 20 -21 67 -197 524 -207 535
-11 14 -104 18 -111 6z"/>
<path d="M4297 6196 c-4 -10 -7 -131 -7 -271 0 -284 -1 -278 72 -273 l43 3 7
64 c4 34 9 68 11 74 2 6 31 12 69 13 110 3 161 31 202 111 30 60 16 158 -32
214 -44 52 -97 69 -236 76 -110 5 -123 4 -129 -11z m232 -107 c71 -25 81 -137
14 -168 -13 -6 -46 -11 -73 -11 l-50 0 0 95 0 95 39 0 c21 0 52 -5 70 -11z"/>
<path d="M4772 5918 l3 -273 175 -7 c131 -5 177 -4 183 5 7 11 3 84 -5 93 -3
2 -57 7 -121 10 l-117 7 -1 176 c0 97 -3 194 -7 216 l-7 40 -53 3 -52 3 2
-273z"/>
<path d="M5362 6158 c-11 -14 -192 -503 -192 -519 0 -6 24 -9 58 -7 l57 3 60
173 c33 96 65 173 70 173 10 -1 53 -104 54 -128 1 -8 -12 -13 -33 -13 -31 0
-36 -4 -51 -44 -17 -44 -14 -68 8 -65 7 1 37 1 68 0 l56 -1 19 -52 19 -53 49
-3 c27 -2 52 0 56 5 10 10 -185 524 -202 535 -20 12 -84 9 -96 -4z"/>
<path d="M5721 6152 c-8 -3 -11 -79 -11 -268 l0 -265 53 3 52 3 2 143 c1 79 4
146 6 149 3 3 51 -63 106 -146 55 -82 110 -155 121 -161 12 -6 33 -10 48 -8
l27 3 0 265 0 265 -47 3 -48 3 0 -146 c0 -113 -3 -146 -12 -143 -7 2 -57 69
-111 148 -93 138 -99 145 -136 150 -21 3 -43 4 -50 2z"/>
<path d="M6234 6131 c-7 -8 -4 -520 4 -524 4 -3 84 -6 177 -8 l170 -4 3 39 c2
21 -2 44 -8 50 -6 6 -61 13 -123 16 l-112 5 -3 58 -3 59 103 -4 103 -3 3 47 3
46 -105 7 c-108 8 -108 8 -108 50 0 8 0 27 1 41 l1 27 115 -7 115 -7 0 50 c0
49 -1 50 -32 55 -42 7 -298 12 -304 7z"/>
<path d="M6614 6107 c-3 -8 -4 -30 -2 -49 l3 -33 60 -3 c33 -2 64 -7 69 -12 5
-5 12 -103 15 -217 l6 -208 50 0 50 0 -4 212 -4 212 69 3 69 3 -1 43 c0 23 -3
44 -5 46 -2 2 -86 7 -186 11 -159 6 -184 5 -189 -8z"/>
<path d="M4010 5901 c0 -49 1 -50 33 -56 17 -3 64 -5 102 -3 l70 3 0 50 0 50
-102 3 -103 3 0 -50z"/>
<path d="M2500 5482 c0 -14 97 -172 141 -229 67 -87 210 -215 296 -266 45 -26
87 -46 94 -44 8 2 10 2 6 -1 -15 -8 97 -54 189 -77 51 -13 129 -27 175 -30
117 -10 349 20 349 44 0 5 -12 6 -26 3 -20 -4 -25 -2 -19 8 4 7 2 16 -6 21 -8
4 9 6 41 4 36 -2 48 0 35 5 l-20 9 20 1 20 1 -20 9 c-17 7 -17 9 -2 9 9 1 17
6 17 11 0 7 -7 7 -21 0 -16 -9 -26 -8 -45 5 -13 8 -24 19 -24 24 0 5 -18 7
-40 4 -28 -4 -40 -2 -40 7 0 7 8 10 20 7 11 -3 20 -2 20 3 0 4 20 14 45 21 25
7 45 17 45 22 0 5 -8 6 -17 2 -48 -18 -131 -35 -206 -41 -272 -22 -591 132
-757 367 -79 111 -76 109 -180 109 -49 0 -90 -4 -90 -8z m605 -414 c-9 -6 -19
-7 -22 -4 -4 3 -1 6 6 6 7 0 9 4 6 10 -4 6 1 7 11 3 15 -6 15 -7 -1 -15z m501
-67 c-4 -5 0 -11 6 -14 8 -2 9 -8 4 -13 -5 -5 -11 -4 -13 4 -3 6 -12 12 -21
13 -14 0 -13 2 3 9 27 11 27 11 21 1z m-136 -11 l45 -9 -47 3 c-26 2 -45 0
-42 -5 8 -14 -19 -10 -40 6 -19 14 -18 15 10 14 16 0 49 -4 74 -9z m90 -24
c-15 -15 -33 4 -19 20 10 12 14 12 20 2 5 -7 4 -17 -1 -22z m140 -11 c0 -14
-4 -25 -10 -25 -5 0 -10 9 -10 19 0 17 -4 19 -32 10 -42 -12 -71 -12 -63 1 3
5 12 7 20 4 7 -3 22 -1 32 5 10 6 28 11 41 11 17 0 22 -6 22 -25z m-346 6 c4
-5 -3 -7 -14 -4 -23 6 -26 13 -6 13 8 0 17 -4 20 -9z m206 -32 c0 -5 -9 -9
-20 -9 -22 0 -27 16 -7 23 15 5 27 -1 27 -14z m40 -24 c0 -8 -2 -15 -4 -15 -2
0 -6 7 -10 15 -3 8 -1 15 4 15 6 0 10 -7 10 -15z m-423 -1 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m448 -33 c3 -6 -3 -9 -12 -9 -10 1 -34 -2
-53 -6 -24 -6 -32 -5 -25 2 6 6 24 12 40 15 17 2 33 5 37 6 4 0 9 -3 13 -8z
m65 3 c0 -8 -19 -13 -24 -6 -3 5 1 9 9 9 8 0 15 -2 15 -3z m-270 -8 c0 -2 -7
-6 -15 -10 -8 -3 -15 -1 -15 4 0 6 7 10 15 10 8 0 15 -2 15 -4z m80 -10 c0 -2
-16 -6 -35 -8 -19 -2 -35 0 -35 4 0 4 16 8 35 8 19 0 35 -2 35 -4z"/>
<path d="M2887 5449 c30 -52 139 -163 152 -154 9 5 7 13 -6 28 -18 22 -18 22
4 4 21 -18 22 -18 52 4 17 13 31 24 31 25 0 1 -12 27 -26 58 l-25 56 -62 1
c-34 1 -69 2 -77 3 -8 0 -18 -3 -22 -9 -5 -6 -8 -5 -8 3 0 6 -7 12 -16 12 -13
0 -13 -4 3 -31z m167 -5 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14
-7z m40 -50 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m-9 -24
c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z"/>
<path d="M3141 5443 c16 -45 37 -67 51 -56 7 5 43 20 81 33 37 13 67 27 67 30
0 7 -109 20 -172 20 -36 0 -37 -1 -27 -27z m126 -8 c-4 -9 -17 -9 -76 0 -43 7
-32 12 24 11 33 0 54 -4 52 -11z m-64 -18 c-2 -4 -5 -7 -8 -7 -3 0 -12 0 -21
0 -8 0 -13 4 -10 9 7 10 42 8 39 -2z"/>
<path d="M3433 5453 c20 -2 54 -2 75 0 20 2 3 4 -38 4 -41 0 -58 -2 -37 -4z"/>
<path d="M3602 5449 c2 -6 33 -22 68 -36 95 -36 104 -38 96 -24 -4 6 -12 9
-17 6 -5 -4 -9 1 -9 9 0 10 -9 16 -22 17 -22 0 -22 1 -3 9 28 12 67 12 60 0
-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -4 11 -18 24 -14 37 9 11 21 10 21 -69 18
-44 -2 -78 -1 -75 3 2 5 -8 8 -22 8 -15 0 -25 -5 -23 -11z"/>
<path d="M3853 5433 c-3 -10 -8 -22 -11 -27 -3 -5 0 -6 6 -2 6 3 13 -2 15 -11
3 -10 5 -4 4 12 l-2 30 63 1 c88 2 91 14 3 14 -59 0 -73 -3 -78 -17z"/>
<path d="M4015 5440 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M4205 5439 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M4370 5419 c-7 -11 -10 -23 -7 -25 2 -2 9 7 15 21 14 30 7 33 -8 4z"/>
<path d="M4177 5405 c-4 -8 -2 -17 3 -20 6 -4 10 3 10 14 0 25 -6 27 -13 6z"/>
<path d="M4000 5395 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M3414 5394 c-14 -6 3 -85 20 -96 14 -10 62 -10 52 -1 -4 4 -17 8 -29
8 -18 0 -22 7 -25 43 -2 26 2 42 8 42 6 0 9 -8 6 -18 -4 -13 0 -18 14 -19 17
-2 18 1 10 18 -9 16 -7 19 8 19 10 0 23 -5 29 -11 6 -6 17 -8 25 -3 9 6 6 10
-12 15 -29 8 -90 10 -106 3z"/>
<path d="M3822 5366 c-9 -21 -6 -26 37 -58 l47 -35 37 36 c20 20 37 43 37 51
-1 9 -7 4 -15 -10 -7 -14 -17 -25 -22 -25 -5 0 -17 -8 -27 -18 -25 -25 -42
-10 -18 17 14 15 17 27 12 41 -6 13 -9 15 -9 5 -1 -15 -27 -37 -46 -38 -5 0
-9 4 -7 9 1 5 -3 9 -9 9 -6 0 -8 9 -4 20 9 27 1 25 -13 -4z m73 -36 c-10 -11
-21 -17 -24 -14 -3 3 3 12 13 20 28 20 32 17 11 -6z"/>
<path d="M3262 5355 c-48 -22 -52 -27 -42 -45 6 -11 15 -20 20 -20 6 0 10 -7
10 -15 0 -8 4 -15 9 -15 21 0 19 18 -4 42 -13 14 -21 29 -18 32 12 12 23 6 23
-14 0 -11 5 -20 11 -20 6 0 8 8 4 19 -4 15 2 23 26 35 17 9 35 13 40 10 5 -3
9 0 9 5 0 18 -31 12 -88 -14z"/>
<path d="M4131 5340 c-18 -22 -30 -46 -28 -53 4 -8 6 -8 6 2 1 7 9 21 19 30
18 15 47 61 39 61 -2 0 -18 -18 -36 -40z"/>
<path d="M3510 5345 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
<path d="M3590 5339 c-6 -11 -9 -25 -6 -32 2 -7 5 -4 5 6 1 10 5 16 9 13 4 -2
8 4 8 15 0 24 -3 24 -16 -2z"/>
<path d="M3656 5347 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M3334 5335 c3 -8 9 -22 12 -30 4 -9 0 -17 -10 -20 -53 -17 -51 -15
-36 -26 11 -8 10 -9 -7 -4 -13 3 -23 2 -23 -3 0 -20 15 -20 54 1 22 12 42 22
43 23 1 0 0 17 -4 37 -3 23 -11 37 -20 37 -10 0 -13 -6 -9 -15z"/>
<path d="M3620 5340 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3686 5323 c3 -14 7 -30 10 -35 3 -4 -1 -5 -9 -2 -8 3 -18 1 -22 -5
-3 -6 -1 -11 5 -11 6 0 8 -6 5 -12 -4 -7 7 2 24 21 31 35 33 55 4 44 -10 -4
-14 -2 -9 5 3 6 2 13 -3 17 -6 3 -8 -6 -5 -22z"/>
<path d="M3287 5313 c-7 -35 -1 -41 19 -22 8 9 12 23 8 32 -9 25 -21 21 -27
-10z"/>
<path d="M3511 5304 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4296 5293 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M3123 5279 c-32 -20 -36 -46 -6 -35 8 3 11 1 8 -4 -3 -6 2 -13 12
-17 10 -4 20 -10 23 -13 3 -4 31 -16 63 -28 43 -15 55 -17 46 -6 -6 8 -18 14
-25 14 -8 0 -13 3 -13 8 3 19 -2 25 -11 12 -8 -13 -10 -12 -10 2 0 10 -7 26
-15 35 -8 10 -20 26 -27 35 -12 17 -15 16 -45 -3z"/>
<path d="M3726 5223 c-48 -52 -55 -64 -35 -58 43 13 149 67 149 75 0 5 -12 17
-28 28 l-27 20 -59 -65z m77 22 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15
13 8 -4z m-59 -30 c-4 -8 -11 -15 -16 -15 -6 0 -5 6 2 15 7 8 14 15 16 15 2 0
1 -7 -2 -15z"/>
<path d="M3602 5272 c-9 -3 -2 -11 17 -23 18 -10 34 -19 36 -19 10 0 5 29 -7
36 -7 4 -8 3 -4 -4 4 -7 3 -12 -3 -12 -5 0 -14 6 -18 14 -4 7 -14 11 -21 8z"/>
<path d="M4059 5258 c-5 -18 -6 -38 -1 -34 7 8 12 36 6 36 -2 0 -4 -1 -5 -2z"/>
<path d="M3440 5240 c0 -19 24 -100 30 -100 6 0 30 81 30 100 0 6 -13 10 -30
10 -16 0 -30 -4 -30 -10z"/>
<path d="M3342 5224 c-30 -12 -32 -15 -19 -29 8 -8 21 -16 28 -17 8 -2 20 -11
27 -20 7 -10 19 -18 25 -18 7 0 4 5 -6 11 -12 7 -15 15 -9 22 6 8 5 22 -2 39
-11 25 -12 26 -44 12z m38 -18 c0 -2 -7 -9 -15 -16 -12 -10 -15 -10 -15 4 0 9
7 16 15 16 8 0 15 -2 15 -4z"/>
<path d="M3549 5185 c-9 -25 -15 -45 -12 -45 2 0 25 14 50 31 46 32 47 43 3
54 -22 5 -27 1 -41 -40z m41 15 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8
10 11 10 2 0 4 -4 4 -10z"/>
<path d="M4004 5208 c-12 -14 -13 -18 -3 -10 9 6 18 10 21 7 2 -3 5 2 5 10 0
19 0 19 -23 -7z"/>
<path d="M4211 5184 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3968 5173 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3924 5148 c-4 -7 -4 -10 1 -6 4 4 14 3 22 -4 11 -8 12 -7 7 6 -7 19
-20 21 -30 4z"/>
<path d="M4174 5144 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z"/>
<path d="M3979 5133 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M3881 5122 c-14 -9 -47 -27 -75 -40 -28 -13 -39 -21 -25 -18 43 9 94
33 113 55 23 25 19 26 -13 3z"/>
<path d="M4118 5089 c-11 -18 -22 -27 -29 -23 -8 5 -9 3 -5 -5 9 -14 40 9 57
41 17 31 -5 19 -23 -13z"/>
<path d="M3890 5060 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3986 4995 c-74 -51 -79 -61 -8 -20 34 21 62 41 62 46 0 11 4 13 -54
-26z"/>
<path d="M3755 4990 c-17 -7 -15 -9 13 -9 17 -1 32 4 32 9 0 12 -17 12 -45 0z"/>
<path d="M3883 4946 c-13 -6 -23 -14 -23 -18 0 -5 -7 -8 -15 -8 -9 0 -27 -7
-40 -16 -13 -9 -29 -13 -35 -9 -5 3 -10 1 -10 -5 0 -15 36 -7 96 22 40 18 62
36 53 42 -2 1 -14 -3 -26 -8z"/>
<path d="M3810 4940 c12 -8 12 -10 1 -10 -8 0 -12 -2 -9 -5 3 -3 13 -2 22 1
14 5 15 9 4 15 -7 5 -17 9 -23 9 -5 0 -3 -5 5 -10z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
